import { render } from "./commentOne.vue?vue&type=template&id=0ec0ca91&scoped=true&ts=true"
import script from "./commentOne.vue?vue&type=script&lang=ts"
export * from "./commentOne.vue?vue&type=script&lang=ts"

import "./commentOne.vue?vue&type=style&index=0&id=0ec0ca91&lang=less"
import "./commentOne.vue?vue&type=style&index=1&id=0ec0ca91&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/www.soyoung.com-vue3-pc-master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec0ca91"]])

export default __exports__